import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { isArray as p } from "./code-utils.js";

var Zt = /*#__PURE__*/function () {
  function Zt() {
    _classCallCheck(this, Zt);
  }

  _createClass(Zt, [{
    key: "tf",
    value: function tf() {}
  }, {
    key: "ef",
    value: function ef() {}
  }, {
    key: "Ko",
    value: function Ko(t) {}
  }], [{
    key: "rf",
    value: function rf(t, e) {
      if (t && e) if (t = t.toLowerCase(), p(e.if)) {
        for (var r = 0; r < e.if.length; r++) {
          if (-1 !== t.indexOf(e.if[r].toLowerCase())) return e.identity;
        }
      } else if (-1 !== t.indexOf(e.if.toLowerCase())) return e.identity;
    }
  }]);

  return Zt;
}();

export { Zt as default };